import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-info-user-temporal-card',
    templateUrl: './info-user-temporal-card.component.html',
    styleUrls: ['./info-user-temporal-card.component.scss'],
})
export class InfoUserTemporalCardComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
